'use client';

import { useEffect } from 'react';
import type { FormValues, FormInstance } from '../types';
import { saveFormState } from '../utils/storage';

interface UseFormPersistenceProps {
  localStorageKey: string;
  values: FormValues;
  currentStepId: string;
  completedForms: Record<string, FormInstance[]>;
}

/**
 * Hook to handle form state persistence to localStorage
 */
export const useFormPersistence = ({
  localStorageKey,
  values,
  currentStepId,
  completedForms,
}: UseFormPersistenceProps) => {
  useEffect(() => {
    if (!currentStepId) return;
    // Debounce localStorage writes to avoid excessive writes
    const timeoutId = setTimeout(() => {
      saveFormState(localStorageKey, {
        values,
        currentStepId,
        completedForms,
      });
    }, 100); // Wait 100ms after last change (reduced from 300ms for faster updates)

    return () => {
      clearTimeout(timeoutId); // Cleanup timeout
    };
  }, [localStorageKey, values, currentStepId, completedForms]);
};
